module.exports = __webpack_public_path__ + "static/img/customer7.25a02509.png";